/* VIP Vape — Streamline mobile drawer level-3 scroll reset.
   Problem: when a user scrolls down a long level-2 list (e.g. Disposable Vapes,
   26 items) and taps a sub-item (e.g. Oxbar) to open the short level-3 panel
   (5 items), Streamline preserves the overflow container's scrollTop from the
   level-2 list. The short level-3 panel appears blank because the scroll
   position is past all its content.

   Fix: on any level-3-triggering button click, reset scrollTop to 0 on the
   drawer scroll containers AFTER Streamline's goToSubnav() reveals the panel.
   - Event delegation on document; no preventDefault; does not override theme.js.
   - Scoped to mobile only and to buttons that open a level-3 panel
     (data-target^="tier-3-"). */
(function () {
  if (window.__vvSlideNavScrollReset) return;
  window.__vvSlideNavScrollReset = true;

  function resetSlideNavScroll() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document
      .querySelectorAll('.slide-nav__overflow, .slide-nav__wrapper')
      .forEach(function (el) {
        el.scrollTop = 0;
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(
      '.slide-nav button[data-target^="tier-3-"]'
    );
    if (!trigger) return;

    requestAnimationFrame(function () {
      resetSlideNavScroll();
      requestAnimationFrame(resetSlideNavScroll);
    });
  });
})();
